import { Badge, Text } from '@mantine/core';
import React from 'react';

interface Props {
  status?: string | undefined;
}
function StatusText(props: Props) {
  const { status } = props;

  const dynamicBadge = () => {
    if (status === 'DISABLED') {
      return (
        <Badge style={{ width: '120px' }} color='gray' size='md'>
          Disabled
        </Badge>
      );
    } else if (status === 'APPROVED') {
      return (
        <Badge style={{ width: '120px' }} color='green' size='md'>
          Approved
        </Badge>
      );
    } else if (status === 'DECLINED') {
      return (
        <Badge style={{ width: '120px' }} color='red' size='md'>
          Declined
        </Badge>
      );
    } else if (status === 'PENDING') {
      return (
        <Badge style={{ width: '120px' }} color='orange' size='md'>
          Pending
        </Badge>
      );
    } else if (status === 'NEW') {
      return (
        <Badge style={{ width: '120px' }} size='md'>
          New
        </Badge>
      );
    } else if (status === 'ENABLED') {
      return (
        <Badge style={{ width: '120px' }} color='green' size='md'>
          Enabled
        </Badge>
      );
    } else if (status === 'ACTIVATED') {
      return (
        <Text size='sm' color='green'>
          Activated
        </Text>
      );
    } else if (status === 'NOT_ACTIVATED') {
      return (
        <Text size='sm' color='dimmed'>
          Not yet activated
        </Text>
      );
    } else {
      return (
        <Text size='sm' color='dimmed'>
          N/A
        </Text>
      );
    }
  };
  return <>{dynamicBadge()}</>;
}

export default StatusText;
